export default __webpack_public_path__ + "static/media/northern_lights2.0538d851.webp";